import React, { FC } from 'react';
import { useController, UseControllerProps } from 'react-hook-form';
import ErrorMessage from '@components/profile/profileOverlay/common/ErrorMessage';

import styles from '../../prize.module.scss';
import classnames from 'classnames/bind';
const cx = classnames.bind(styles);

type IPrizeInstitutionProps = Omit<UseControllerProps, 'name'> & {
  prefixName: string;
  institutionDefaultValue?: string;
};
const PrizeInstitution: FC<IPrizeInstitutionProps> = ({ prefixName, institutionDefaultValue, ...props }) => {
  const fieldName = `${prefixName}.institution`;
  const {
    field: institutionField,
    fieldState: { invalid: institutionInvalid },
  } = useController({
    ...props,
    name: fieldName,
    defaultValue: institutionDefaultValue ?? '',
  });

  return (
    <div className={cx('awardWrap')}>
      <div className={cx('awardTitle')}>수여 기관</div>

      <div className={cx('inputArea')}>
        <input
          {...institutionField}
          className={cx('input', { error: institutionInvalid })}
          type="text"
          placeholder={'수여 기관을 입력해주세요.'}
          maxLength={35}
          autoComplete="off"
        />
        <ErrorMessage name={fieldName} />
      </div>
    </div>
  );
};

export default PrizeInstitution;
